(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("bpview", [], factory);
	else if(typeof exports === 'object')
		exports["bpview"] = factory();
	else
		root["bpview"] = factory();
})(window, function() {
return 